var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 4.50146V28.5015C40 29.6015 39.6087 30.5435 38.826 31.3275C38.042 32.1101 37.1 32.5015 36 32.5015H4C2.9 32.5015 1.95867 32.1101 1.176 31.3275C0.392 30.5435 0 29.6015 0 28.5015V4.50146C0 3.40146 0.392 2.46013 1.176 1.67746C1.95867 0.893465 2.9 0.501465 4 0.501465H36C37.1 0.501465 38.042 0.893465 38.826 1.67746C39.6087 2.46013 40 3.40146 40 4.50146ZM4 8.50146H36V4.50146H4V8.50146ZM4 16.5015V28.5015H36V16.5015H4Z",
    fill: "#2BAAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.9a582ef98e87d7298477fd86363c9431.svg";
export { ForwardRef as ReactComponent };